import logDatapoint from './logDatapoint';
import { ServiceActionDatapoint } from './datapoints/ServiceActionDatapoint';
import getResourceTimingForUrl from './utils/getResourceTimingForUrl';
import CalculatedResourceTimings from './types/CalculatedResourceTimings';
import RequestOptions from 'owa-service/lib/RequestOptions';
import { DataPointEventType } from './types/DatapointEnums';

export default function captureServiceActionOptics(
    responsePromise: Promise<Response>,
    actionName: string,
    url: string,
    attemptCount: number,
    options: RequestOptions
) {
    let datapoint = new ServiceActionDatapoint(actionName, options, attemptCount);
    return responsePromise
        .then(response => {
            datapoint.addResponseDiagnostics(response);
            if (options?.datapoint) {
                if (options.datapoint.headersCustomData && response) {
                    datapoint.addCustomData(options.datapoint.headersCustomData(response.headers));
                }
                if (options.datapoint.jsonCustomData) {
                    return response
                        .clone()
                        .json()
                        .then(json => {
                            datapoint.addCustomData(options.datapoint.jsonCustomData(json));
                        });
                }
            }
            return Promise.resolve();
        })
        .catch(error => {
            datapoint.addErrorDiagnostics(error);
        })
        .then(() => {
            return getResourceTimingForUrl(url);
        })
        .then((timing: CalculatedResourceTimings) => {
            if (timing) {
                datapoint.addResourceTimings('ServiceAction', timing);
            }
            logDatapoint(datapoint, DataPointEventType.ClientNetworkRequest);
        });
}
